import { render, staticRenderFns } from "./LockReason.vue?vue&type=template&id=2d00cb0b"
import script from "./LockReason.vue?vue&type=script&lang=js"
export * from "./LockReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports